import { isVendorProfileComplete } from "@/helpers/vendor.helpers";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");
  const location = useLocation();
  const user = useSelector((state) => state.auth.auth);

  const currentPath = location.pathname;
  const isVendorRoute = currentPath.startsWith("/vendor");
  const isCustomerRoute = currentPath.startsWith("/customer");

  const isVendorAuthPage = currentPath.startsWith("/vendor/auth");
  const isCustomerAuthPage = currentPath.startsWith("/customer/auth");

  const onboardingRoute = "/vendor/onboarding/profile-wizard";
  const isOnboardingPage = currentPath.startsWith("/vendor/onboarding");
  const isInOnboarding = localStorage.getItem("in_progress_onboarding") === "true";

  // Redirect unauthenticated users to the correct login
  const isPublicCustomerPage = currentPath.startsWith("/customer/search-brokers");
  const isPublicHomePage = currentPath === "/";

  if (!isAuthenticated) {
    if (isPublicCustomerPage) {
      return children;
    }
    if (isPublicHomePage) {
      return children;
    }
    if (isVendorRoute && !isVendorAuthPage) {
      return <Navigate to="/vendor/auth/login" replace />;
    }
    if (isCustomerRoute && !isCustomerAuthPage) {
      return <Navigate to="/customer/auth/login" replace />;
    }
    return <Navigate to="/customer/auth/login" replace />;
  }

  if (isPublicHomePage) {
    return children;
  }
  // Handle vendor routes
  if (role === "vendor") {
    if (isCustomerRoute) {
      return <Navigate to="/vendor/dashboard" replace />;
    }

    if(user._id){
      console.log("user",user);
      const isProfileComplete = isVendorProfileComplete(user);
          // If onboarding is in progress, allow onboarding routes
      if (isInOnboarding) {
        if (!isOnboardingPage) {
          return <Navigate to="/vendor/onboarding/upload-profile-image" replace />;
        }
        // Let user access onboarding routes while onboarding is in progress
        return children;
      }

      // If profile is incomplete and not already on the wizard page, force redirect
      console.log("isProfileComplete",isProfileComplete,"====","isOnboardingPage",isOnboardingPage);
      if (!isProfileComplete && !isOnboardingPage) {
        return <Navigate to={onboardingRoute} replace />;
      }
    }
  }

  // Handle customer routes
  if (role === "customer" && isVendorRoute) {
    if (isPublicHomePage) {
      console.log("customer----");
      return children;
    }else{
      return <Navigate to="/customer/search-brokers" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;